import React from 'react';
import { firestore } from '../../contexts/FirebaseContext';
import useAuthUsers from '../useAuthUsers';
import { updateCartAction } from '../../redux/slices/dagpacket';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';

function useCupones() {
  const { currentUser, currentHostUser } = useAuthUsers();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const getCuponByCode = async (idCupon) => {
    const cupon = await (await firestore.collection('cupones_dag').doc(idCupon).get())?.data();

    console.log(cupon);
    return cupon;

    // if (cupon) {
    //   return true;
    // }
    // return false;
  };

  const verificarUsoCuponDagpacket = (arrHist) => {
    if (arrHist.length === 0) return true;

    if (arrHist.length !== 0 && arrHist[0].reason === 'reset-cupon') return true;

    return false;
  };

  const crearCupon = async (data) => {
    const verifyExistence = await getCuponByCode(data.cuponCode);

    if (!verifyExistence) {
      await firestore.collection('cupones_dag').doc(data.cuponCode).set(data);
      const res = await firestore.collection('cupones_dag_historial').add({
        cuponId: data.cuponCode,
        tipoCupon: data.tipoCupon,
        createdAt: new Date(),
        reason: 'creation',
        userId: currentUser.id,
        valor: data.valor,
        tipoValor: data.tipoValor,
        // al item al que se le aplica el cupon
        objetoAplicadoId: ''
      });
      return res;
    }

    throw new Error('El cupon ya existe');
  };

  const handleStatusCupon = async (data, active = true) => {
    try {
      await firestore
        .collection('cupones_dag')
        .doc(data.cuponCode)
        .update({
          status: active ? 'active' : 'inactive',
          updatedAt: new Date()
        });

      const res = await firestore.collection('cupones_dag_historial').add({
        cuponId: data.cuponCode,
        tipoCupon: data.tipoCupon,
        createdAt: new Date(),
        reason: `${active ? 'active-status' : 'inactive-status'}`,
        userId: currentUser.id,
        valor: data.valor,
        tipoValor: data.tipoValor,
        // al item al que se le aplica el cupon
        objetoAplicadoId: ''
      });

      return res;
    } catch (error) {
      throw new Error('Error al actualizar cupon');
    }
  };

  const updateCupon = async (data) => {
    try {
      await firestore.collection('cupones_dag').doc(data.cuponCode).update(data);
      const res = await firestore.collection('cupones_dag_historial').add({
        cuponId: data.cuponCode,
        tipoCupon: data.tipoCupon,
        createdAt: new Date(),
        reason: 'update',
        userId: currentUser.id,
        valor: data.valor,
        tipoValor: data.tipoValor,
        // al item al que se le aplica el cupon
        objetoAplicadoId: ''
      });
      return res;
    } catch (error) {
      throw new Error('Error al actualizar cupon');
    }
  };

  // eslint-disable-next-line consistent-return
  const passLimiteUso = (limiteUso, usos) => {
    if (limiteUso === 'ilimitado') {
      return true;
    }
    if (Number(limiteUso) > Number(usos)) {
      return true;
    }
    if (Number(limiteUso) <= Number(usos)) {
      return false;
    }
  };

  const passLimiteTiempo = (tiempoDesde, tiempoHata) => {
    const desde = new Date(tiempoDesde);
    const hasta = new Date(tiempoHata);
    const now = new Date();

    if (tiempoDesde === '' && tiempoHata === '') {
      return true;
    }
    if (now >= desde && now <= hasta) {
      return true;
    }

    return false;
  };

  const getCuponValue = (valor, tipoValor, objectItemPrice) => {
    if (tipoValor === 'numero') {
      const result = valor;
      return result;
    }

    const result = Math.ceil(Number(objectItemPrice) * (valor / 100));
    return result;
  };

  const usarCupon = async (idCupon, objectItem) => {
    // console.log(idCupon, objectItem);
    // con esto obtenemos el cupon por su codigo y nos aseguramos que este activo caso contrarion que findedCupon sea null
    const requestCup = await getCuponByCode(idCupon);

    // console.log(requestCup);
    const findedCupon = requestCup.status === 'active' ? requestCup : null;

    const permitedUser = ['cajero'].includes(currentUser.role) ? currentHostUser.id : currentUser.id;

    if (
      (findedCupon && findedCupon.privacyUse === 'general') ||
      (findedCupon && findedCupon.privacyUse === 'particular' && findedCupon.forUserCupon === permitedUser)
    ) {
      const { cuponCode, fechaDesde, fechaHasta, limiteUso, tipoValor, usos, valor, tipoCupon } = findedCupon;

      const cuponValue = getCuponValue(valor, tipoValor, objectItem.shippingValue);

      if (passLimiteUso(limiteUso, usos) && passLimiteTiempo(fechaDesde, fechaHasta)) {
        // console.log('se pudo pasar ==========');
        if (tipoCupon === 'CUPON-DAGPACKET') {
          const obj = {
            cuponAplicado: true,
            cuponValue,
            cuponId: idCupon,
            tipoCupon: findedCupon.tipoCupon,
            utilidad: Number(objectItem.utilidad) - cuponValue,
            // utilidadEnvioLicen: ,
            utilidadEnvioDagpacket: Number(objectItem.utilidadEnvioDagpacket) - cuponValue,
            shippingValue: Number(objectItem.shippingValue) - cuponValue,
            applyCuponDate: new Date(),
            updated_at: new Date()
          };

          const arrHistorialCupon = (
            await firestore
              .collection('cupones_dag_historial')
              .where('cuponId', '==', idCupon)
              .where('clientePhone', '==', objectItem.phone_from)
              .orderBy('createdAt', 'desc')
              .get()
          ).docs.map((item) => ({ ...item.data() }));

          // console.log(arrHistorialCupon);

          if (verificarUsoCuponDagpacket(arrHistorialCupon)) {
            await firestore.collection('cotizaciones').doc(objectItem.object_id).update(obj);

            await firestore
              .collection('cupones_dag')
              .doc(cuponCode)
              .update({ usos: usos + 1 });

            await firestore.collection('cupones_dag_historial').add({
              cuponId: cuponCode,
              tipoCupon: findedCupon.tipoCupon,
              createdAt: new Date(),
              reason: 'apply-cupon',
              userId: currentUser.id,
              valor,
              tipoValor,
              // al item al que se le aplica el cupon
              objetoAplicadoId: objectItem.object_id,
              // con esto identificaremos si a este cliente le afecto el cupon
              clientePhone: objectItem.phone_from,
              clienteNombre: objectItem.name_from
            });

            const updatedObj = await (
              await firestore.collection('cotizaciones').doc(objectItem.object_id).get()
            ).data();

            dispatch(updateCartAction(updatedObj));

            return updatedObj;
          }

          enqueueSnackbar('Este usuario ya uso un cupon de bienvenida', { variant: 'error' });
          throw new Error('este usuario ya uso un cupon de bienvenida');
        }
        if (tipoCupon === 'CUPON-LICENCIATARIO') {
          const obj = {
            cuponAplicado: true,
            cuponValue,
            cuponId: idCupon,
            tipoCupon: findedCupon.tipoCupon,
            utilidad: Number(objectItem.utilidad) - cuponValue,
            // utilidadEnvioLicen: ,
            utilidadEnvioLicen: Number(objectItem.utilidadEnvioLicen) - cuponValue,
            shippingValue: Number(objectItem.shippingValue) - cuponValue,
            applyCuponDate: new Date(),
            updated_at: new Date()
          };

          await firestore.collection('cotizaciones').doc(objectItem.object_id).update(obj);

          await firestore
            .collection('cupones_dag')
            .doc(cuponCode)
            .update({ usos: usos + 1 });

          await firestore.collection('cupones_dag_historial').add({
            cuponId: cuponCode,
            tipoCupon: findedCupon.tipoCupon,
            createdAt: new Date(),
            reason: 'apply-cupon',
            userId: currentUser.id,
            valor,
            tipoValor,
            // al item al que se le aplica el cupon
            objetoAplicadoId: objectItem.object_id,

            clientePhone: objectItem.phone_from,
            clienteNombre: objectItem.name_from
          });

          const updatedObj = await (await firestore.collection('cotizaciones').doc(objectItem.object_id).get()).data();

          dispatch(updateCartAction(updatedObj));

          return updatedObj;
        }
        if (tipoCupon === 'CUPON-COMPUESTO') {
          const newUtilityEnvio = Number(objectItem.utilidad) - cuponValue;

          const obj = {
            cuponAplicado: true,
            cuponValue,
            cuponId: idCupon,
            tipoCupon: findedCupon.tipoCupon,
            utilidad: newUtilityEnvio,
            // utilidadEnvioLicen: ,
            utilidadEnvioLicen: Math.ceil(newUtilityEnvio * (70 / 100)),
            utilidadEnvioDagpacket: Math.ceil(newUtilityEnvio * (30 / 100)),
            shippingValue: Number(objectItem.shippingValue) - cuponValue,
            applyCuponDate: new Date(),
            updated_at: new Date()
          };

          await firestore.collection('cotizaciones').doc(objectItem.object_id).update(obj);

          await firestore
            .collection('cupones_dag')
            .doc(cuponCode)
            .update({ usos: usos + 1 });

          await firestore.collection('cupones_dag_historial').add({
            cuponId: cuponCode,
            tipoCupon: findedCupon.tipoCupon,
            createdAt: new Date(),
            reason: 'apply-cupon',
            userId: currentUser.id,
            valor,
            tipoValor,
            // al item al que se le aplica el cupon
            objetoAplicadoId: objectItem.object_id,

            clientePhone: objectItem.phone_from,
            clienteNombre: objectItem.name_from
          });

          const updatedObj = await (await firestore.collection('cotizaciones').doc(objectItem.object_id).get()).data();

          dispatch(updateCartAction(updatedObj));

          return updatedObj;
        }
      }
    }

    throw new Error('Este cupon no existe.');
  };

  const restaurarCupon = async (dataItem) => {
    const requestCup = await getCuponByCode(dataItem?.cuponId);

    await firestore
      .collection('cupones_dag')
      .doc(dataItem?.cuponId)
      .update({ usos: requestCup.usos - 1 });

    await firestore.collection('cupones_dag_historial').add({
      cuponId: requestCup.cuponCode,
      tipoCupon: requestCup.tipoCupon,
      createdAt: new Date(),
      reason: 'reset-cupon',
      userId: currentUser.id,
      valor: requestCup.valor,
      tipoValor: requestCup.tipoValor,
      // al item al que se le aplica el cupon
      objetoAplicadoId: dataItem.object_id,

      clientePhone: dataItem.phone_from,
      clienteNombre: dataItem.name_from
    });
  };

  return { crearCupon, updateCupon, getCuponByCode, usarCupon, handleStatusCupon, restaurarCupon };
}

export default useCupones;
